export default __webpack_public_path__ + "static/media/asset_wallet_hive.b7cf5786.svg";